import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const eventSabadell = (value) => {
	//const { i18n } = useTranslation();

	const tealium_data = {
		pagina: {
			
			nombreLink: 'click_cta'
		},
		
		
		eventos: {
			click_cta_info: `plataforma gibobs:portal usuario gibobs:${value}`
		}
	};

	window.bsSend('link', tealium_data);
};
export default eventSabadell;
